import styled from 'styled-components';

export const NewsTextContent = styled.p`
    font-family: Roboto Condensed, serif;
    color: black;
    font-size: 15px;  
    font-weight: 300;
    margin: 25px;
    line-height: 1.3;
    white-space: pre-wrap;
`;

export const NewsDateContent = styled.p`
    font-family: Roboto Condensed, serif;
    color: #696969;
    font-size: 15px;  
    font-weight: 300;
    margin: 25px;
    margin-bottom: 30px;
`;

